import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { MkgError } from "../class/mkg-error";
@Injectable()
export class RequestInterceptor implements HttpInterceptor {

    URL_TO_INTERCEPT = environment.migrate.URL;


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (request.url.endsWith("graphql")) {
            // The graphql requests can't have line breaks(\n) into queries
            if (request.body?.query) {
                const cleanQuery = (request.body.query as string).replace(/\s+/g, ' ').trim();
                const cloned = request.clone({
                    body: { ...request.body, query: cleanQuery },
                });

                return next.handle(cloned);
            }
        }

        let attempts = 0
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => throwError(() => {
                if (error.status === 0) {
                    console.warn("Conexão instável com o servidor")
                }

                return new MkgError({
                    error,
                    body: request.body,
                    method: request.method,
                    headers: request.headers,
                    urlWithParams: request.urlWithParams,
                    attempts
                })
            }))
        );
    }
}
